<script lang="ts">
const useNativeDatepicker = !!document.documentElement.ontouchstart && !!document.createElement('input').showPicker;

let onInputLazy = (_e: any) => { };
</script>

<script setup lang="ts">
import { ref, computed, onUnmounted } from 'vue';
import { dateFormat, dateUnformat } from '@/core/utils/date';
import type { Props, Emits } from './inputDate';
import TopInput from '@/components/forms/input/input.vue';
import { useI18n } from '@/core/plugins/i18n';

const i18n = useI18n();
const props = withDefaults(defineProps<Props>(), {
	icon2: '',
});

const emit = defineEmits<Emits>();

onUnmounted(() => {
	if ($el) {
		$el.datepicker('destroy');
	}
});

const el = ref();
let $el: any;

const localValue = computed({
	get() {
		return dateFormat(props.modelValue, 2, undefined, '0000-00-00');
	},

	set(value) {
		value = dateUnformat(value, '0000-00-00');

		emit('update:modelValue', value);
	},
});

let oninput = (e: any) => {
	onInputLazy(e);
};

let onchange = (e: any) => {
	const date = dateUnformat(e.target.value);
	const dateFormatted = dateFormat(date);

	if (!dateFormatted || dateFormatted === i18n.Common.Not_date || e.target.value !== dateFormatted) {
		e.target.value = localValue.value;

		return;
	}

	localValue.value = e.target.value;
};

/**
 * Инициализпация функций выбора дат
 *
 * Для не нативного datepicker
 */
async function init(e: any) {
	const datepicker = await import('./datepicker');

	// формат ввода
	onInputLazy = datepicker.oninput;

	// datepicker
	$el = datepicker.connectDatepicker(e.target, {
		onSelect: () => onchange(e),
	});

	if ($el) {
		$el.datepicker('show');
	}
}
</script>

<template>
	<TopInput
		v-if="useNativeDatepicker"
		:="$props"
		:modelValue="localValue"
		readonly
		@click="el.showPicker()"
	>
		<input
			ref="el"
			type="date"
			class="top-input_input-date"
			:value="modelValue"
			@change="(e: any) => localValue = e.target.value"
			tabindex="-1"
		/>
	</TopInput>

	<TopInput
		v-else
		:="$props"
		:modelValue="localValue"
		@update:modelValue="(newValue) => (newValue === '') ? localValue = '' : ''"
		@input.date="oninput"
		@focus.once.date="init"
		@change.date="onchange"
		modificator="datepicker"
	/>
</template>

<style>
.top-input-datepicker {
	width: calc(105px + var(--top-icon-width) + var(--top-icon2-width));
}

.top-input_input-date {
	opacity: 0;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: -1;
}

.top-input_input-date::-webkit-inner-spin-button {
	display: none;
}

.top-input_input-date::-webkit-calendar-picker-indicator {
	opacity: 0;
}
</style>
